import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import qs from "qs";

/**  공통함수
 * @class
 * */
export var Comm = {
    /**
     * 서브미션 호출(요청 파라미터를 xml인스턴스 형태로 호출) - 그리드 데이터(옵션)
     *
     * @param pSubId :submission id 명 ex) subList
     * @param pAction :호출할 action url ex) /rt/rt/rtrt0010e01/selectList.do
     * @param pJson: Json | null – : 보낼 Json data
     * @param pSyncYn :동기화 여부 ( Y(동기)/N, "" (비동기) )
     * @param psCallback : return 할 method 명 ex) doCallBack
     * @param poGridId :데이터를 가져올 그리드 id
     * @param psMode :그리드 상태 옵션 'A':그리드 모든 데이터 'M':갱신,삽입,삭제 'C':삽입 'D':삭제 'U':갱신 default:'M'
     */
    extSubmission : function ( pSubId , pAction , pJson , pSyncYn , psCallback ) {
        try {
            this.extSubmissionAll(pSubId , pAction , null , pJson , pSyncYn , psCallback);
        } catch (e) {
            // console.log(e)
            
        }
    } ,
    
    /**
     * wrapperId 기준 하위 객체 중 prefix 로 시작하는 모든 객체를 ''로 Set
     *
     * @param {string} wrapperId : 상위 객체 아이디(요소들을 wrapping 한 Element ID)
     * @param {string | null } prefix : blank 로 만들 하위 객체의 prefix, 없을 경우 모든 객체
     * @param {Array | null } exceptedIdArray : 예외 객체     *
     *
     * @example
     * Comm.fillBlank('grp_detail', 'INF_');
     *
     */
    fillBlank : function ( wrapperId , prefix , exceptedIdArray ) {
        var elements = Comm.getComps(wrapperId , prefix , exceptedIdArray , "group textbox  wframe");
        elements.forEach(function ( k ) {
            try {
                if ( (k.options.pluginName ?? "") === "" ) {
                } else if ( k.options.pluginName === "inputCalendar" ) {
                    k.setValue(Date.today().toString(k.options.ioFormat));
                } else if ( k.options.pluginName === "autoComplete" ) {
                    k.setDummyData("" , "");
                } else if ( k.options.pluginName === "image" ) {
                } else {
                    k.setValue("");
                }
            } catch (e) {
            }
        });
    } ,
    //     /**
    //  * validation function
    //  * @param wrapperId <String> value 요소들을 wrapping 한 Element ID
    //  * @param prefix <String> prefix에 해당하는 객체만 수집
    //  * @param exceptedIdArray <Array> 예외 ID
    //  * @returns boolean
    //  */
    //     checkCompsValidate : function (wrapperId, prefix, exceptedIdArray) {
    //         try{
    //             var elements = Comm.getComps(wrapperId, prefix, exceptedIdArray, "group textbox wframe img")  ;
    //             var returnVal = true ;
    //             var cnt = elements.length;
    //             for ( var i = 0; i < cnt; i++) {
    //                 try{ 
    //                     var tmp = WebSquare.util.getComponentById( elements[i].id );
    //                     var key = elements[i].id.replace(new RegExp('^'+prefix),'');
    //                     var tlt = this.getCtrlTitle(tmp)   ;
    
    //                     // websquare 객체인지 체크
    //                     if(tmp === null || (exceptedIdArray !== null && this.containsValueInArray(exceptedIdArray, key) === true)){
    //                         continue;
    //                     }
    //                     if( tmp.getDisabled() === true  ){
    //                         continue ;
    //                     }
    //                     if(!( tmp.hasClass('essential') === true  || (tmp.element.className).indexOf("essential") >= 0 ) ){
    //                         continue ;
    //                     }
    //                     // null 이면
    //                     var val = (tmp.getValue() ?? "")   ;
    //                     if( val === ''){
    //                         alert(tlt + '을(를) 입력해 주세요.');
    //                         tmp.focus();
    //                         returnVal = false ;
    //                         return false;
    //                     }
    //                     // 캘린더 타입 체크
    //                     if(tmp.element.tagName === 'w2:inputCalendar'){
    //                         // 날짜 체크
    //                         if(DateUtil.isDate(val) === false){
    //                             alert(tmp.element.getAttribute('title') + '은(는) 정확한 날짜 입력 형식이 아닙니다.');
    //                             tmp.focus();
    //                             returnVal = false ;
    //                             return false;
    //                         }
    //                     }
    //                 }catch(e){
    //                 }
    //             }
    //         }catch (e1) {
    //          //   console.log(e1)   ;
    
    //         }
    //         return returnVal  ;
    // }  ,
    
    /**
     * array Json 에서 Key,value  해당하는 Object 리턴
     *
     * @param array : 대상 array Json
     * @param _key
     * @param _value
     * @returns {boolean|array}
     */
    
    getListinArrayJson : function ( array , _key , _value ) {
        if ( array === null ) {
            return false;
        }
        return array.filter(( item ) => item[_key] === _value);
    } ,
    
    /**
     * 오즈리포트 띄우는 팝업/iframe 공통
     * @param poParam 오즈파일설정 파람들
     poParam.ozrName = ozr 파일명 (확장자 포함) ex)"sampleTest.ozr"
     poParam.odiName = odi 파일명 (파일명만)"sampleTest"
     poParam.odiParm = odi에 보낼 파람
     poParam.ozrParm = ozr에 보낼 파람 ex) "TitleName||매출순위(광고회사)";
     poParam.pWidth = width 값 ex) "1200";
     poParam.pHeight = height 값 ex) "1000";
     poParam.fileName = 한글파일명 ex)"테스트";
     * @param poJson 그리드 데이터(array)
     * @param iframeId iframe의 ID값(string)
     */
    callOzPopup : function ( poParam , poJson ) {
        try {
            const url = "/modules/ozviewer/commPrint.jsp";
            const option = "width=1210,height=880";
            let requestData = {
                ozrName : poParam.ozrName ,
                odiName : poParam.odiName ,
                odiParm : (Array.isArray(poParam.odiParm) ? poParam.odiParm : [poParam.odiParm]) ,
                ozrParm : (Array.isArray(poParam.ozrParm) ? poParam.ozrParm : [poParam.ozrParm]) ,
                pWidth : poParam.pWidth ,
                pHeight : poParam.pHeight ,
                fileName : poParam.fileName
            };
            
            //그리드 데이터
            if ( (poJson ?? "") !== "" ) {
                let replaceList = {};
                let mkJson = [];
                let arr = {};
                let arrlist = [];
                for ( var i = 0 ; i < poJson.length ; i ++ ) {
                    var vsSetName = poJson[i].setName;
                    var jsonarr = poJson[i].data;
                    for ( var key in jsonarr ) {
                        for ( var key2 in jsonarr[key] ) {
                            try {
                                arr[key2] = jsonarr[key][key2].toString();
                            } catch (e) {
                                arr[key2] = '';
                            }
                        }
                        arrlist.push(arr);
                        arr = {};
                    }
                    replaceList[i] = arrlist;
                    mkJson.push(replaceList[i]);
                    arrlist = [];
                    replaceList = {};
                    requestData[vsSetName] = mkJson[i];
                }
                
                requestData.ozData = poJson;
                requestData.isJson = true;
                requestData.datafromserver = false;
            } else {
                requestData.isJson = false;
                requestData.datafromserver = true;
            }
            
            var moOzParam = this.getOzParam();
            moOzParam.globalObj.params = requestData;
            
            window.open(url , '' , option);
        } catch (e) {
            //  console.log(e)   ;
        }
    } ,
    
    
    callOzPopupCable : function(poParam, poJson =[])  {
   		try {
   			var option = "";
   			var vsWidth = poParam.pWidth  ;
   			var vsHeight = poParam.pHeight ;
   			option = "width=" + vsWidth + ",height=" + vsHeight;
   
   			var requestData = poParam;
   			var url = "/modules/ozviewer/svgViewCable.jsp";
      
      
   			if (poJson !== null && Object.keys(poJson).length > 0) {
   				requestData.ozData = poJson;
   				requestData.isJson = true;
   				requestData.datafromserver = false;
   			} else {
   				requestData.datafromserver = true;
   			}
            var moOzParam = this.getOzParam();
            moOzParam.globalObj.params = requestData;
            
   			window.open(url, '', option);
   		} catch (Err) {
   			console.log(Err)  ;
   		}
   	},
    
    /**
     * 오즈 리포트 팝업에서 파람값을 가져옴.
     * @param key
     * @returns
     */
    getOzParamValue : function ( key ) {
        var moOzParam = window.top.globalObj != null ? window.top : Comm.getOzParam();
        if ( moOzParam.globalObj == null || moOzParam.globalObj.params == null ) {
            return null;
        }
        
        if ( key == null ) {
            return moOzParam.globalObj.params;
        } else {
            return moOzParam.globalObj.params[key];
        }
    } ,
    
    /**
     * 오즈 리포트 팝업에 보낼 파람 셋팅.
     * @returns {___moOzParam1}
     */
    getOzParam : function () {
        var moOzParam;
        try{
            if ( window.dialogArguments != null ) {
                moOzParam = window.dialogArguments.top;
            } else if ( window.opener != null ) {
                moOzParam = window.opener.top;
            } else {
                moOzParam = window.top;
            }
            moOzParam.globalObj = moOzParam.globalObj != null ? moOzParam.globalObj : {};
            moOzParam.globalObj.params = moOzParam.globalObj.params != null ? moOzParam.globalObj.params : {};
        }catch (e) {
            console.log(e)
        }
        return moOzParam;
    } ,
    
    /**
     * 메소디아 바로가기
     */
    goMethodia : function () {
        var url = "/websquare/websquare.jsp?w2xPath=/modules/layout.do";
        window.open(url , '_blank' , '');
    } ,
    /**
     * 메소디아 바로가기
     */
    goSMethodia : function () {
        var url = "/cpm/modules/";
        window.open(url , '_blank' , '');
    } ,
    
    
    handleDownloadPdf :  async(pRef = null , fileNm) => {
        if(pRef === null) return ;
        const element = pRef.current; // 참조된 HTML 요소
        if(!element) return ;
        try{
            const canvas = await html2canvas(element, { useCORS: true, scale: 2 }); // HTML -> Canvas 변환 (고해상도 및 외부 이미지 대응)
            const orientation =  element.offsetWidth >= element.offsetHeight ? 'l' : 'p'
            
            const imgData = canvas.toDataURL("image/png"); // Canvas -> 이미지 데이터로 변환
            const pdf = new jsPDF(orientation , "px", "a4"); // PDF 인스턴스 생성 (A4 용지 기준)
        
            // 캡처된 이미지를 PDF에 추가
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pageWidth ; 
            const imgHeight = (canvas.height * imgWidth) / canvas.width; 
            let heightLeft = imgHeight;
        
            let position = 0;
        
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        
            // 여러 페이지가 필요한 경우 루프를 통해 추가
            while (heightLeft > 0) {
              position = heightLeft - imgHeight; // 새 페이지 위치 설정
              pdf.addPage();
              pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
            }
            pdf.save(fileNm +".pdf"); // PDF 다운로드
        }catch (e) {
            console.error("PDF Download Error:", e);
        }
    },
    

    
    // 소재 팝업
     mtrlPopup :  (mtrlParam) => {
       
         if (!mtrlParam.isDisabled) {
             const options = "top=10, left=10, status=no, menubar=no, toolbar=no, resizable=no, width=1000, height=600";
             const querys = {
                 w2xPath : encodeURI("/modules/common/commPFindMtrl.xml") ,
                 popupID : `cpm_popup_${Math.floor(Math.random() * 1000)}` ,
                 agncyId : mtrlParam?.agncyId ,
                 cliId : mtrlParam?.cliId ,
                 vpMtrlSec : mtrlParam?.sec || "15" ,
                 callbackFunc : mtrlParam?.callbackFunc ,
                 vpMtrlKndCd : "SOA01" ,
             };
             const url = `/websquare/popup.jsp?${qs.stringify(querys)}`;
             const name = "commPFindMtrl";
             window.open(url , name , options);
         }
    },
    
    // 두 날짜 사이의 수요일 개수 계산 함수 (moment.js 이용)
    getDaysBetweenPeriod : (startDate, endDate , wkCode ) => {
        const start = new Date(startDate.replace(/\D/g, "").replace(/(\d{4})(\d{2})(\d{2})/ , "$1-$2-$3"));
        const end = new Date(endDate.replace(/\D/g, "").replace(/(\d{4})(\d{2})(\d{2})/ , "$1-$2-$3"));
    
        let count = 0;
        
        // 날짜를 순회하며 요일 확인
        while (start <= end) {
            if (start.getDay() === wkCode ) { // 수요일 (일요일 = 0, 월요일 = 1, ..., 수요일 = 3)
                count++;
            }
            start.setDate(start.getDate() + 1); // 하루씩 증가
        }
        return count;
    }

    
}

window.Comm  =  Comm  ;
